import type { LayerKind } from "@/layers/utility/createLayerObject";
import type { GeoJSONFeatureCollection } from "@mm/api.meteomatics.com";
import type { GenericGeoJsonRequest } from "@mm/api.meteomatics.com";

export function generateGenericCacheId(
  req: Pick<GenericGeoJsonRequest, "path" | "area" | "datetime" | "query">,
  kind?: LayerKind,
): string {
  const bbox = req.area ? JSON.stringify(req.area) : "";
  const q = req.query ? JSON.stringify(req.query) : "";
  const t = req.datetime ? String((req as any).datetime?.valueOf?.() ?? req.datetime) : "";
  return [kind ?? "generic", req.path, bbox, t, q].join("|");
}

export function mergeFeatureCollections(list: GeoJSONFeatureCollection[]): GeoJSONFeatureCollection {
  const merged: GeoJSONFeatureCollection = { type: "FeatureCollection", features: [] };
  for (const fc of list) {
    if (fc?.features?.length) {
      merged.features.push(...fc.features);
    }
  }
  return merged;
}
